import {
  Button,
  Alert,
  Card,
  CardBody,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import AppSpinner from "../../elements/AppSpinner";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import { useEffect, useState } from "react";
import AdminNavbar from "../../components/Navbars/IndexNavbar";
import AuthHeader from "../../components/Headers/AuthHeader";
import API from "../../api/api/API";
import RightArrow from "../../elements/RightArrow";
import Password from "../../components/Inputs/Password";
import AuthFooter from "../../components/Footers/AuthFooter";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [password, setPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [validPassword, setValidPassword] = useState(false);
  const [validConfirmation, setValidConfirmation] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const token = url.searchParams.get("token");
    const email = url.searchParams.get("email");

    if (!token || !email) return navigate("/login", { replace: true });

    setToken(token);
    setEmail(email);
  }, []);

  function reset(e: any) {
    e.preventDefault();

    setSubmitting(true);
    setError("");

    API.resetPassword(token, password, retypePassword)
      .then(
        (data) => {
          setSuccess(true);
        },
        (error: any) => {
          if (error.response && error.response.status === 401) {
            setError(
              "Oops! It looks like your password reset link has expired. Please request a new one."
            );
          } else if (error.response.data.httpStatus === 400) {
            setError(error.response.data.message);
          } else {
            setError(
              "We're having trouble updating your password. Please try again."
            );
          }
        }
      )
      .finally(() => {
        setSubmitting(false);
      });
  }

  return (
    <>
      <AppHelmet title="Reset Password - GrowthCloud.com" />

      <div className="main-content">
        <AdminNavbar bg="" />
        <AuthHeader title="Update Your Password" lead="" />
        <Container className="pb-5">
          <Row className="justify-content-center">
            <Col lg="6" xl="5" md="8">
              <Card className="bg-white shadow border-0 mb-0 mt--3">
                {success ? (
                  <CardBody className="px-lg-5 pt-5">
                    <h3 className="text-center">
                      Your Password Has Been Updated
                    </h3>
                    <p className="mb-4 text-center">
                      You can now use your updated password to login.
                    </p>
                    <div className="text-center">
                      <Button
                        href="/login"
                        className="my-4 px-4"
                        color="primary"
                        type="button"
                      >
                        Return To Login <RightArrow />
                      </Button>
                    </div>
                  </CardBody>
                ) : (
                  <CardBody className="px-lg-5 pt-5">
                    <p className="mb-5 text-center">
                      Enter a new password below.
                    </p>
                    <Form role="form" onSubmit={reset}>
                      <FormGroup>
                        <Password
                          placeholder="New Password"
                          onChange={(e: any) => setPassword(e.target.value)}
                          // @ts-ignore
                          setValidPassword={setValidPassword}
                          userEmail={email}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Password
                          placeholder="Re-Type New Password"
                          name="retypePassword"
                          onChange={(e: any) =>
                            setRetypePassword(e.target.value)
                          }
                          // @ts-ignore
                          setValidPassword={setValidConfirmation}
                          userEmail={email}
                        />
                      </FormGroup>
                      <div className="text-center">
                        <Button
                          disabled={
                            submitting ||
                            password !== retypePassword ||
                            !password ||
                            !validPassword ||
                            !validConfirmation
                          }
                          className="my-4 px-4"
                          color="primary"
                          type="submit"
                        >
                          {submitting ? (
                            <span className="px-4">
                              <AppSpinner
                                style={{ height: 20, width: 20 }}
                                color="white"
                              />
                            </span>
                          ) : (
                            <>
                              Update Password <RightArrow></RightArrow>
                            </>
                          )}
                        </Button>
                      </div>
                      {error ? <Alert color="warning">{error}</Alert> : null}
                    </Form>
                  </CardBody>
                )}
              </Card>
              <Row className="mt-3">
                <Col xs="6">
                  <Link className="text-light" to="/login">
                    <small>Return to Login</small>
                  </Link>
                </Col>
                <Col className="text-right" xs="6">
                  <Link className="text-light" to="/register">
                    <small>
                      Create an account <RightArrow></RightArrow>
                    </small>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </>
  );
}

export default ResetPassword;
